module.exports = __webpack_public_path__ + "static/media/msme.3e909be0.jpg";